module.exports = __webpack_public_path__ + "img/giuliana-margaria-byn.855b0a2d.jpg";